import { TOKEN_KEY, fetchRoles } from "@/api/auth";

const state = {
  roles: undefined,
  profileLoading: false
};

const getters = {
  roles: state => state.roles,
  profileLoading: state => state.profileLoading
};

const mutations = {
  setRoles: (state, payload) => {
    state.roles = payload;
  },
  setProfileLoading: (state, payload) => {
    state.profileLoading = payload;
  }
};

const actions = {
  fetchRoles: async ({ commit }) => {
    // get token for auth.
    const token = localStorage.getItem(TOKEN_KEY);
    // fetch the roles from server.
    const { data } = await fetchRoles(token);
    if (data.status !== 200) {
      console.log(data.message);
    } else {
      commit("setRoles", data.roles);
    }
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
